// extracted by mini-css-extract-plugin
export default {"panel":"AdminSmtpConfigCardSection_panel__kX9iq"};